import { Box} from "@chakra-ui/react";
import ClientContainer from "views/Customers/CustomerList/ClientContainer";
import DriversContainer from "views/Drivers/DriversContainer";
import OrderContainer from "views/Orders/OrderContainer";

const Drivers = ({}) => {
  return (
    <
    >
   <DriversContainer/>
    </>
  );
};

export default Drivers;
